import { types } from 'mobx-state-tree';

import HomeStore from './HomeStore';
import PostStore from './PostStore';
import MapsStore from './MapsStore';
import OfficesStore from './OfficesStore';
import ProgressStore from './ProgressStore';
import ThemeStore from './ThemeStore';
import SceneChangerStore from './SceneChangerStore';
import CursorStore from './CursorStore';
import MenuStore from './MenuStore';
import PreloaderStore from './PreloaderStore';
import EnvStore from './EnvStore';
import LogoStore from './LogoStore';
import ScrollControllerStore from './ScrollControllerStore';
import UIStore from './UIStore';
import AboutStore from './AboutStore';
import ApproachStore from './ApproachStore';
import JobsStore from './JobsStore';

const Store = types.model('Store', {
  home: types.optional(HomeStore, { rows: [], featured: {} }),
  post: types.optional(PostStore, {}),
  maps: types.optional(MapsStore, { items: [] }),
  offices: types.optional(OfficesStore, { items: [] }),
  progress: types.optional(ProgressStore, { loading: false }),
  theme: types.optional(ThemeStore, {}),
  sceneChanger: types.optional(SceneChangerStore, {}),
  cursorStore: types.optional(CursorStore, {}),
  menuStore: types.optional(MenuStore, {}),
  preloaderStore: types.optional(PreloaderStore, {}),
  envStore: types.optional(EnvStore, {}),
  logoStore: types.optional(LogoStore, {}),
  scrollControllerStore: types.optional(ScrollControllerStore, {}),
  UIStore: types.optional(UIStore, {}),
  aboutStore: types.optional(AboutStore, {}),
  approachStore: types.optional(ApproachStore, {}),
  jobsStore: types.optional(JobsStore, {}),
});

export default Store;



// WEBPACK FOOTER //
// ./src/stores/index.js